"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { useElements } from '../element/useElements.mjs';

function usePackages(query) {
  const { ...rest } = useElements("packages", query);
  return {
    packages: rest.items,
    ...rest
  };
}

export { usePackages };
